import React, { useState, useEffect } from 'react';
import { APIProvider, Map, Marker, InfoWindow } from '@vis.gl/react-google-maps';
import { ILocation } from '../../../models/ILocation';
import { Box, Typography } from '@mui/material';
import { typo } from '../../../assets/fonts/font';
import colorConfigs from '../../../configs/colorConfigs';

const GoogleMapComponent: React.FC<{ locations: ILocation[]; selectedLocation: ILocation | null }> = ({ locations, selectedLocation }) => {
  const [infoWindowLocation, setInfoWindowLocation] = useState<ILocation | null>(null);
  const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number }>({ lat: 1.3521, lng: 103.8198 });
  const [zoomLevel, setZoomLevel] = useState<number>(12);

  useEffect(() => {
    if (selectedLocation) {
      setMapCenter({ lat: selectedLocation.lat, lng: selectedLocation.long });
      setZoomLevel(15);
      setInfoWindowLocation(selectedLocation);
    }
  }, [selectedLocation]);

  const handleMarkerClick = (location: ILocation) => {
    setMapCenter({ lat: location.lat, lng: location.long });
    setZoomLevel(15);
    setInfoWindowLocation(location);
  };

  return (
    <APIProvider apiKey="AIzaSyD9sF4ynW2xFLFAbGMITubccMcinHjCtkc">
      <Map zoom={zoomLevel} center={mapCenter}>
        {locations.slice(0, 40).map((location, index) => (
          <Marker
            key={index}
            position={{ lat: location.lat, lng: location.long }}
            onClick={() => handleMarkerClick(location)}
          />
        ))}

        {infoWindowLocation && (
          <InfoWindow
          position={{ lat: infoWindowLocation.lat, lng: infoWindowLocation.long }}
          onCloseClick={() => setInfoWindowLocation(null)}
          
        >
          <Box
            sx={{
              backgroundColor: colorConfigs.quaternary,
              border: "2px solid",
              borderRadius: "8px",
              padding: "10px",
              minWidth: "200px",
            }}
          >
            <Typography sx={{ ...typo.title, color:colorConfigs.primary }}>
              {infoWindowLocation.name}
            </Typography>
            <Typography sx={{ ...typo.smallText }}>Address: {infoWindowLocation.address}</Typography>
            <Typography sx={{ ...typo.smallText }}>Postal Code: {infoWindowLocation.postal_code}</Typography>
          </Box>
        </InfoWindow>        
        )}
      </Map>
    </APIProvider>
  );
};

export default GoogleMapComponent;
